import {
    SET_LAYOUT_FILE,
    SET_LAYOUT_FOLDER,
    SET_DISPALY_LAST_MODIFIED,
    SET_DYSPLAY_OWNER,
    SET_SORT_SEFAULT,
    UPDATE_ERROR_CONNECT
} from '../constants';

export default (state = {showBtn: false, showError:false, editable: false,select_layout:"1", layout_file:"1" ,displayLastModified: "1",displayOwner: "1", sortDefault: "1"}, action) => {
    switch (action.type) {
        case 'UPDATE_CONNECT':
            return {
                ...state,
                showBtn: action.payload
            }
            case UPDATE_ERROR_CONNECT:
                return {
                    ...state,
                    showError: action.payload
                }
        case SET_LAYOUT_FOLDER:
            return {
                ...state,
                select_layout: action.payload
            }
        case SET_LAYOUT_FILE:
            return {
                ...state,
                layout_file: action.payload
            }
        case SET_DISPALY_LAST_MODIFIED:
        return {
            ...state,
            displayLastModified: action.payload
        }
        case SET_DYSPLAY_OWNER:
        return {
            ...state,
            displayOwner: action.payload
        }
        case SET_SORT_SEFAULT:
        return {
            ...state,
            sortDefault: action.payload
        }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/userConnectReducer.js